import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function AlertSuccessText(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false); 
  const [errorInfo, setErrorInfo] = useState(props.errorInfo);
  function pokazText(errorinfo) {
    console.log("someChildFunction" + errorinfo + " s");
    setErrorInfo(errorinfo);
    setOpen(true);
  }
  props.biRef.pokazText = pokazText;
  return (
    <div className={classes.root}>
      <Collapse in={open}>
        <Alert severity="success"
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {errorInfo}
        </Alert>
      </Collapse>
    </div>
  );
}
